import { Route } from '@/types/route'

const flags = ['FEATURE_MERITS_EXCHANGE', 'FEATURE_BOARDING_ROTA'] as const

export type FeatureFlag = typeof flags[number]

const availableFeature = Object.entries(import.meta.env)
  .filter(env => env[0].startsWith('VITE_FEATURE') && env[1] === 'true')
  .map(env => env[0].slice(5))

export function isFeatureEnabled(featureName: FeatureFlag) {
  return availableFeature.includes(featureName)
}

export function checkIsRouteWithFeatureEnabled(route: Route) {
  return route.meta.featureFlag
    ? isFeatureEnabled(route.meta.featureFlag)
    : true
}
